var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('arroba-medellin-arrobita-loading'),(_vm.isPublic && _vm.setting)?_c('div',[_c('NoLogin')],1):(_vm.isPublic)?_c('div',[_c('router-view')],1):_c('div',[_c('Dashboard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }